module.exports = __webpack_public_path__ + "static/media/pilot.7e495071.png";